import { MenuContent, MenuContentProps } from './MenuContent';
import { useMenuContext } from './MenuContext';
import styles from './Menu.module.css';

/**
 * Submenu.Content
 *
 * The floating container for a nested submenu. Behaves like `Menu.Content` but
 * applies submenu-specific positioning styles so it opens beside its trigger
 * row rather than below it. Must be rendered inside a `<Submenu>` context.
 */

export function SubmenuContent({ children, className, ...props }: MenuContentProps) {
  const { align } = useMenuContext();
  return (
    <MenuContent
      className={[styles.submenu, align === 'left' && styles.alignLeft, className]}
      {...props}
    >
      {children}
    </MenuContent>
  );
}
